import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Modal from 'antd/lib/modal';
import Button from 'antd/lib/button';
import { connectModal } from '../../features/modal/hoc';
import message from 'antd/lib/message';
import { t } from '../../app/i18n';

@connectModal('CONFIRM_MODAL')
export default class ConfirmModal extends Component {
  static propTypes = {
    modalActions: PropTypes.object.isRequired,
    isVisible: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
  };

  render() {
    const { modalActions, isVisible, onSubmit, message, children } = this.props;

    return (
      <span>
        {cloneElement(children, { onClick: modalActions.show })}
        {isVisible && (
          <ModalWindow hideModal={modalActions.hide} onSubmit={onSubmit} message={message} />
        )}
      </span>
    );
  }
}

@translate()
export class ModalWindow extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    hideModal: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
  };

  handleConfirm = () => {
    const { onSubmit, hideModal } = this.props;
    onSubmit();    
    hideModal();
  };

  render() {
    const { t, hideModal, message } = this.props;

    return (
      <Modal
        title={t('Potvrdenie')}
        visible
        onCancel={hideModal}
        footer={[
          <Button key="cancel" onClick={hideModal}>
            {t('Nie')}
          </Button>,
          <Button type="primary" key="confirm" onClick={this.handleConfirm}>
            {t('Áno')}
          </Button>,
        ]}
        width={900}
      >
        {message}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ConfirmModal.js